export default __webpack_public_path__ + "static/media/1836.7b5bbb09.png";